import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { useState, useEffect } from "react";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import axios from "axios";
import { jwtDecode } from 'jwt-decode';
import { useToast } from "../../components/ui/ToastContext";
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle, FaExclamationTriangle } from "react-icons/fa";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Avatar from '@mui/material/Avatar';
import { API_URL } from "../../config";
import 'moment/locale/ro';
import CalendarWithTasks from "./Calendarwithtasks";
import MobileDateCarousel from "./MobileDateCarusel";

moment.locale('ro', {
    week: {
        dow: 1,
    },
});

dayjs.extend(utc);
dayjs.extend(timezone);

const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

const weekdayNamesRo = ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'];
const monthNamesRo = [
    'Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie',
    'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'
];
const formats = {
    monthHeaderFormat: (date, culture, localizer) => {
        const month = date.getMonth();
        const year = date.getFullYear();
        return `${monthNamesRo[month]} ${year}`;
    },
    weekdayFormat: (date, culture, localizer) => {
        if (!date) return '';
        const day = date.getDay();
        return weekdayNamesRo[day];
    },
    dayFormat: (date, culture, localizer) => {
        const day = date.getDay();
        return weekdayNamesRo[day];
    },
    dayHeaderFormat: (date) => `${weekdayNamesRo[date.getDay()]}, ${date.getDate()} ${monthNamesRo[date.getMonth()]}`,
    dayRangeHeaderFormat: ({ start, end }, culture, localizer) => {
        const startDay = start.getDate();
        const startMonth = monthNamesRo[start.getMonth()];
        const startYear = start.getFullYear();
        const endDay = end.getDate();
        const endMonth = monthNamesRo[end.getMonth()];
        const endYear = end.getFullYear();

        if (startYear !== endYear) {
            return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
        }
        if (startMonth !== endMonth) {
            return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
        }
        return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
    },
    timeGutterFormat: 'HH:mm',
    eventTimeRangeFormat: ({ start, end }, culture, localizer) =>
        `${localizer.format(start, 'HH:mm')} - ${localizer.format(end, 'HH:mm')}`,
};

const BasicCalendar = () => {
    const { showToast } = useToast();
    const navigate = useNavigate();
    const [events, setEvents] = useState([]);
    const [Data4, setData4] = useState([]);
    const [Data6, setData6] = useState([]);
    const [Data10, setData10] = useState([]);
    const [defaultOption, setDefaultOption] = useState("");
    const [instcity, setinstCity] = useState([]);
    const [userinstData, setUserinstData] = useState([]);
    const [user, setUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const token = localStorage.getItem('jwtToken');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const localizer = momentLocalizer(moment);
    const messages = {
        allDay: 'Toată ziua',
        previous: 'Înapoi',
        next: 'Înainte',
        today: 'Astăzi',
        month: 'Lună',
        week: 'Săptămână',
        day: 'Zi',
        agenda: 'Agendă',
        date: 'Dată',
        time: 'Oră',
        event: 'Eveniment',
        noEventsInRange: 'Nu există evenimente în acest interval.',
        showMore: (total) => `Mai multe (${total})`
    };


    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUser(decoded);
                setDefaultOption(decoded.userId)
            } catch (error) {
                console.error('Error decoding the token:', error);
            }
        }
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/physiciansinstitute`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setUserinstData(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/activitytype`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setData4(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/adressinstitutions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setinstCity(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);

            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/manageuser`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                const users = response.data.filter(
                    (item) => item.manager_user_id === user?.userId
                );

                if (user?.role === 'Admin') {
                    axios.get(`${API_URL}/api/users`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    })
                        .then((response) => {
                            setData10(response.data);
                        })
                        .catch((error) => {
                            console.error("Error fetching users data:", error);
                        });
                }
                else if (users.length > 0) {
                    const subordinateUserId = users.map((item) => item.subordinate_user_id);
                    axios.get(`${API_URL}/api/users`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    })
                        .then((response) => {
                            const filteredUsers = response.data.filter((item) =>
                                subordinateUserId.includes(item.user_id) || item.user_id === user.userId
                            );
                            setData10(filteredUsers);
                        })
                        .catch((error) => {
                            console.error("Error fetching users data:", error);
                        });
                }
                else {
                    const manager = response.data.find((i) => i.subordinate_user_id === user?.userId);
                    if (manager) {
                        const teamUserIds = response.data
                            .filter((item) => item.manager_user_id === manager.manager_user_id)
                            .map((item) => item.subordinate_user_id);

                        axios.get(`${API_URL}/api/users`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type": "application/json",
                            },
                        })
                            .then((response) => {
                                const teamUsers = response.data.filter((item) =>
                                    teamUserIds.includes(item.user_id)
                                );
                                setData10(teamUsers);
                            })
                            .catch((error) => {
                                console.error("Error fetching users data:", error);
                            });
                    } else {
                        setData10([]);
                    }
                }
            }
            )
            .catch((error) => {
                console.error("Error fetching manage data:", error);
            });
    }, [user]);

    const moveEventHandler = ({ event, start, end }) => {
        let updatedEvents = [];
        updatedEvents = events.filter((e) => {
            return e.id !== event.id;
        });
        setEvents([
            ...updatedEvents,
            {
                id: `${event.id}`,
                title: `${event.title}`,
                start: new Date(`${start}`),
                end: new Date(`${end}`),
            },
        ]);
    };

    const resizeEventHandler = ({ event, start, end }) => {
        let updatedEvents = [];
        updatedEvents = events.filter((e) => {
            return e.id !== event.id;
        });
        setEvents([
            ...updatedEvents,
            {
                id: `${event.id}`,
                title: `${event.title}`,
                start: new Date(`${start}`),
                end: new Date(`${end}`),
            },
        ]);
    };

    const hanldeOnSelectEvent = (e) => {
        if (e.activity === "Planificat") {
            confirmDelete(e)
        } else if (e.activity === "Raportat") {
            confirmDelete2(e)
        }
        else if (e.activity === "Alte activitati") {
            confirmDelete3(e)
        }
    };

    const confirmDelete = async (item) => {
        navigate("/planning/reportplanning", { state: { item } });
    };

    const confirmDelete2 = async (item) => {
        navigate("/reporting/viwereporting", { state: { item } });
    };

    const confirmDelete3 = async (item) => {
        navigate("/otheractivity/viweotheractivity", { state: { item } });
    };

    const workHoursStart = new Date();
    workHoursStart.setHours(8, 0, 0);
    const workHoursEnd = new Date();
    workHoursEnd.setHours(19, 0, 0);

    const eventStyleGetter = (event) => {
        let backgroundColor;

        if (event.activity) {
            if (event.activity.startsWith("Planificat")) {
                backgroundColor = "#801F26";
            } else if (event &&
                event.activity &&
                event.activity.startsWith("Raportat") && event?.physician_is_present === true
            ) {
                backgroundColor = "#285133";
            } else if (event &&
                event.activity &&
                event.activity.startsWith("Alte activitati Planificate")) {
                backgroundColor = "#332851";
            } else if (
                event &&
                event.activity &&
                event.activity.startsWith("Alte activitati")
            ) {
                backgroundColor = "#DA9673";
            } else if (event &&
                event.activity &&
                event.activity.startsWith("Activitati planificate")) {
                backgroundColor = "#801F26";
            }

            const style = {
                backgroundColor,
                border: "1px solid #EAEAEA",
                color: "white",
                fontWeight: "bold",
                display: "none !important",
            };
            return { style };
        }

        const style = {
            backgroundColor,
            border: "1px solid #EAEAEA",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            paddingLeft: "5px",
            fontSize: "14px"
        };
        return { style };
    };

    const handleSlotSelectEvent = (slotInfo) => {
        const startDay = dayjs(slotInfo.start).startOf("day");
        const endDay = dayjs(slotInfo.end).endOf("day");

        const selectedEnd = startDay.isSame(endDay, "day")
            ? endDay
            : dayjs(slotInfo.end).subtract(1, "day").endOf("day");

        const selectedStart = startDay;

        const eventsForDay = events.filter(ev => {
            const evStart = dayjs(ev.start);
            const evEnd = dayjs(ev.end);
            return evStart.isBefore(selectedEnd) && evEnd.isAfter(selectedStart);
        });

        showToast({
            message: (
                <div>
                    <p>
                        Vreti sa planificati pentru aceste zile?{" "}
                        {selectedStart.format("DD-MM-YYYY")} -{" "}
                        {selectedEnd.format("DD-MM-YYYY")}
                    </p>
                    <div className="flex gap-2 mt-2">
                        <button
                            className="px-3 py-1 bg-red-700 text-white rounded-md"
                            onClick={() => {
                                confirmDelete1(slotInfo, eventsForDay);
                                showToast({ show: false });
                            }}
                        >
                            Da
                        </button>
                        <button
                            className="px-3 py-1 bg-gray-400 text-white rounded-md"
                            onClick={() => showToast({ show: false })}
                        >
                            Nu
                        </button>
                    </div>
                </div>
            ),
            type: "warning",
            icon: (
                <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />
            ),
        });
    };


    const confirmDelete1 = async (item, eventsForDay) => {
        const firstNotValidated = eventsForDay.find(ev => ev.is_validated === false);
        if (firstNotValidated) {
            navigate("/planning/editplanning", { state: { item: firstNotValidated } });
        } else {
            navigate("/planning/createplanning", { state: { item } });
        }
    };


    const dropdownOptions = Data10.map((region) => ({
        value: region.user_id,
        label: region.user_name_surname
    }));

    const _onSelect = (selectedOption) => {
        setEvents([]);
        setDefaultOption(selectedOption);
    };




    useEffect(() => {
        if (!user?.userId) return;

        axios
            .get(`${API_URL}/api/4calendar`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                params: {
                    user_ids: defaultOption ? defaultOption.toString() : user.userId.toString(),
                },
            })
            .then((response) => {
                setData6(response.data)
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    }, [user, token, defaultOption]);

    function combineDateTime(dateString, timeString) {
        const datePart = dayjs.utc(dateString).format("YYYY-MM-DD");
        const timePart = dayjs.utc(timeString).format("HH:mm:ss");
        return dayjs(`${datePart}T${timePart}`);
    }

    useEffect(() => {
        const occupiedSlots = {};
        Data6.forEach((detail) => {
            let start = null;
            let end = null;

            if (detail.type === 'Raportat') {
                start = combineDateTime(detail.date, detail.start_time);
                end = combineDateTime(detail.date, detail.end_time);
            } else if (detail.type === 'Alte activitati Planificate') {
                start = combineDateTime(detail.date, detail.oad_start_time);
                end = combineDateTime(detail.date, detail.oad_end_time);
            }
            else if (detail.type === 'Alte activitati') {
                start = combineDateTime(detail.date, detail.start_time);
                end = combineDateTime(detail.date, detail.end_time);
            }
            if (start && end) {
                if (!occupiedSlots[detail.date]) {
                    occupiedSlots[detail.date] = [];
                }
                occupiedSlots[detail.date].push({ start, end });
            }
        });

        function isTimeSlotFree(date, start, end) {
            const slots = occupiedSlots[date] || [];
            return !slots.some(slot =>
                start.isBefore(slot.end) && end.isAfter(slot.start)
            );
        }

        const combinedEvents = Data6.map((detail) => {
            const startPlanned = combineDateTime(detail.date, detail.oad_start_time);
            const endPlanned = combineDateTime(detail.date, detail.oad_end_time);

            switch (detail.type) {
                case 'Raportat': {
                    let title = "Raportare necunoscută";
                    const startRaport = combineDateTime(detail.visit_date, detail.start_time);
                    const endRaport = combineDateTime(detail.visit_date, detail.end_time);

                    if (detail.obiect_type_id === 1) {
                        const user = userinstData.find(i => i.institute_assign_id === detail.object_id);
                        title = user ? `${user.user_name_surname} - ${user.spec} - ${user.inst}` : "Utilizator necunoscut";
                    } else {
                        const city = instcity.find(i => i.id === detail.object_id);
                        title = city ? `${city.inst} - ${city.adres}` : "Oraș necunoscut";
                    }

                    return {
                        planning_day_id: detail.planning_day_id,
                        title,
                        start: startRaport.toDate(),
                        end: endRaport.toDate(),
                        activity: detail.type,
                        planning_detail_id: detail.planning_detail_id,
                        comment: detail.comment,
                        type: 'Raportat',
                        planning_id: detail.planning_id,
                        is_validated: detail.is_validated,
                        report_detail_id: detail.report_detail_id,
                        user_id: detail.user_id,
                        physician_is_present: detail.physician_is_present

                    };
                }

                case 'Alte activitati': {
                    const activityTitle = Data4.find(i => i.activity_type_id === detail.activity_type_id)?.description + " - " + (Data4.find(i => i.activity_type_id === detail.activity_type_id)?.oad_comment || "") || 'Alte activități';
                    const startRaport = combineDateTime(detail.visit_date, detail.start_time);
                    const endRaport = combineDateTime(detail.visit_date, detail.end_time);

                    return {
                        planning_day_id: detail.planning_day_id,
                        title: activityTitle,
                        start: startRaport.toDate(),
                        end: endRaport.toDate(),
                        activity: detail.type,
                        planning_detail_id: detail.planning_detail_id,
                        persons: detail.persons,
                        comment: detail.oad_comment,
                        type: detail.type,
                        planning_id: detail.planning_id,
                        is_validated: detail.is_validated,
                        report_detail_id: detail.report_detail_id,
                        user_id: detail.user_id,
                    };
                }
                case 'Alte activitati Planificate': {
                    const activityTitle = Data4.find(i => i.activity_type_id === detail.activity_type_id)?.description + " - " + (Data4.find(i => i.activity_type_id === detail.activity_type_id)?.oad_comment || "") || 'Alte activități';

                    return {
                        planning_day_id: detail.planning_day_id,
                        title: activityTitle,
                        start: startPlanned.toDate(),
                        end: endPlanned.toDate(),
                        activity: detail.type,
                        planning_detail_id: detail.planning_detail_id,
                        persons: detail.persons,
                        comment: detail.oad_comment,
                        type: detail.type,
                        planning_id: detail.planning_id,
                        is_validated: detail.is_validated,
                        user_id: detail.user_id,
                    };
                }

                case 'Planificat': {
                    let plannedTitle = "Necunoscut";

                    if (detail.obiect_type_id === 1) {
                        const user = userinstData.find(i => i.institute_assign_id === detail.object_id);
                        plannedTitle = user ? `${user.user_name_surname} - ${user.spec} - ${user.inst}` : "Utilizator necunoscut";
                    } else {
                        const city = instcity.find(i => i.id === detail.object_id);
                        plannedTitle = city ? `${city.inst} - ${city.adres}` : "Oraș necunoscut";
                    }

                    let eventStart = dayjs(detail.date).hour(8).minute(30).second(0);
                    let eventEnd = eventStart.add(30, 'minute');

                    // Caută primul interval liber în acea zi
                    while (!isTimeSlotFree(detail.date, eventStart, eventEnd)) {
                        eventStart = eventEnd;
                        eventEnd = eventStart.add(30, 'minute');
                    }

                    if (!occupiedSlots[detail.date]) occupiedSlots[detail.date] = [];
                    occupiedSlots[detail.date].push({ start: eventStart, end: eventEnd });

                    return {
                        planning_day_id: detail.planning_day_id,
                        title: plannedTitle,
                        start: eventStart.toDate(),
                        end: eventEnd.toDate(),
                        activity: detail.type,
                        planning_detail_id: detail.planning_detail_id,
                        type: 'Planificat',
                        planning_id: detail.planning_id,
                        is_validated: detail.is_validated,
                        user_id: detail.user_id,
                    };
                }

                default:
                    return null;
            }
        }).filter(event => event !== null);
        setEvents(combinedEvents);
    }, [Data6, userinstData, instcity, Data4]);

    const handleEventClick = (event) => {
        hanldeOnSelectEvent(event);
    };

    const handleDateSelect = (date) => {
        setSelectedDate(date);
    };

    return (
        <div className="flex flex-col">
            <div className="flex flex-col lg:flex-row gap-4">
                {(user?.role !== 'User' && dropdownOptions.length > 0) && (
                    <div className="hidden lg:block md:block lg:w-1/5">
                        <div className="relative space-y-2 mt-4 max-h-[70vh] overflow-y-auto">
                            <input
                                type="text"
                                placeholder="Caută utilizator..."
                                className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-violet-500 border-gray-300"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                            />
                            {dropdownOptions
                                .filter((option) => option.label.toLowerCase().includes(searchTerm))
                                .map((option) => {
                                    const userData = Data10.filter((user) => user.user_id === option.value);
                                    return (
                                        <div key={option.value} className="flex items-center gap-2 p-2 border-b">
                                            <div
                                                className={`w-full p-2 rounded cursor-pointer transition-all duration-300 ${defaultOption === option.value
                                                    ? 'bg-violet-500 text-white dark:bg-violet-700'
                                                    : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200'
                                                    }`}
                                                onClick={() => _onSelect(option.value)}
                                            >
                                                <div className="flex">
                                                    <Avatar src={userData[0]?.avatar} sx={{ height: '40px', width: '40px' }} />
                                                    <div className="ml-4">
                                                        <h3 className="text-sm">{option.label}</h3>
                                                        {userData.map((user, index) => (
                                                            <div
                                                                className={`text-sm cursor-pointer transition-all duration-300 ${defaultOption === option.value
                                                                    ? 'bg-violet-500 text-white dark:bg-violet-700'
                                                                    : 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-300'
                                                                    }`}
                                                                key={index}
                                                            >
                                                                {user.role_name === 'User'
                                                                    ? 'Utilizator'
                                                                    : user.role_name === 'Admin'
                                                                        ? 'Administrator'
                                                                        : user.role_name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                )}

                <div className={`${user?.role !== 'User' ? 'lg:w-4/5 w-full' : 'w-full'} flex flex-col gap-4`}>

                    <div className="hidden md:block">
                        <div className="my-calendar">
                            <DnDCalendar
                                localizer={localizer}
                                events={events}
                                startAccessor="start"
                                endAccessor="end"
                                selectable
                                eventPropGetter={eventStyleGetter}
                                onSelectSlot={handleSlotSelectEvent}
                                onSelectEvent={hanldeOnSelectEvent}
                                onEventDrop={moveEventHandler}
                                resizable
                                onEventResize={resizeEventHandler}
                                longPressThreshold={10}
                                min={workHoursStart}
                                max={workHoursEnd}
                                style={{ height: 700 }}
                                messages={messages}
                                firstDay={2}
                                formats={formats}
                                draggableAccessor={() => false}
                                resizableAccessor={() => false}
                            />
                        </div>

                        <div className="hidden sm:flex justify-between mt-4">
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#801F26' }}></div>
                                <h3 className="text-sm ml-1">Vizite planificate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#285133' }}></div>
                                <h3 className="text-sm ml-1">Vizite raportate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#332851' }}></div>
                                <h3 className="text-sm ml-1">Alte activități Planificate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#DA9673' }}></div>
                                <h3 className="text-sm ml-1">Alte activități raportate</h3>
                            </div>
                        </div>

                        <div className="sm:hidden md:hidden md:grid grid-cols-2 gap-x-4 gap-y-2 mt-4">
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#801F26' }}></div>
                                <h3 className="text-sm ml-1">Vizite planificate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#285133' }}></div>
                                <h3 className="text-sm ml-1">Vizite raportate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#332851' }}></div>
                                <h3 className="text-sm ml-1">Alte activități Planificate</h3>
                            </div>
                            <div className="flex items-center">
                                <div className="w-20 h-3 rounded-lg" style={{ backgroundColor: '#DA9673' }}></div>
                                <h3 className="text-sm ml-1">Alte activități raportate</h3>
                            </div>
                        </div>
                    </div>

                    <div className="md:hidden">
                        <MobileDateCarousel
                            events={events}
                            selectedDate={selectedDate}
                            onDateSelect={handleDateSelect}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <CalendarWithTasks
                    selectedDate={selectedDate}
                    onDateSelect={setSelectedDate}
                    onEventClick={handleEventClick}
                />
            </div>
        </div>
    );
};

export default BasicCalendar;